import React from 'react'
import {DashboardsTypeOption} from "./select-type";


type Props = {
    dashboardTypeConfig : DashboardsTypeOption
    onSelect            : (template: any) => void
}

export default function QuickAdd_NewDashboard_TypeItem(props: Props) {
    const { dashboardTypeConfig, onSelect } = props

    const handleClick = () => {
        onSelect(dashboardTypeConfig)
    }

    const classes = Classes("dashboard-template flex-row-left-center w-100p m-r-20")


    const style         = {
        backgroundImage     : "url('/app/web/skin/common/modules/dashboard/dashboard-preview/"+gd.skin.layoutTheme+"/"+dashboardTypeConfig.preview+"')",
        backgroundPosition  : "center",
        backgroundRepeat    : "no-repeat",
        backgroundSize      : "contain",
        width               : "90px",
        height              : "60px",
        borderRadius        : "8px",
    }

    // const imgClasses = Classes("m-l-20 ui5-bg-gray ui5-border-all flex-no-shrink")

    return (
        <div className={classes} onClick={handleClick}>

            <div className="preview flex-row-left-top">
                <div className="thumbnail" style={style} />
            </div>

            <div className="flex-column-left-top m-l-20 flex-1">
                <div className="flex-row-left-center m-t-5">
                    <div className="ui5-title-smaller-dark">
                        {dashboardTypeConfig.title}
                    </div>
                    {
                        dashboardTypeConfig.comingSoon &&
                        <div className="ui5-prop gray m-l-15">Coming soon</div>
                    }
                </div>

                <div className="ui5-txt-not-important-small m-t-10 lh-14em">
                    {dashboardTypeConfig.description}
                </div>
            </div>

            <div className="preview flex-row-center-center w-100">
                {!dashboardTypeConfig.comingSoon &&
                    <div className="i5-long-arrow-right ui5-txt-not-important-small "></div>
                }
            </div>

        </div>
    )
}